import Card from '../Card';
import Image from 'next/image';
import BodySmall from '../Text/BodySmall';
import Head3 from '../Text/Head3';

interface CardInfoProps {
  data: {
    srcImage?: string;
    title?: string;
    datePost?: string;
    subtitle?: string;
    mainInfo?: boolean;
  }[];
  containerClassname?: string;
}

const CardInfo = ({ data = [] }: CardInfoProps) => {
  return (
    <div className="flex flex-col md:flex-row flex-wrap items-stretch gap-4 text-black">
      {data?.map((items, index) => {
        const flexMainMenu = items.mainInfo
          ? 'basis-1/2 border-b border-reliableBlack20'
          : 'flex-1 border-b border-reliableBlack20';
        return (
          <Card className={flexMainMenu} key={index}>
            <div className="block bg-white overflow-hidden h-full">
              <div className="relative w-full h-3/6 aspect-video">
                <Image
                  src={items?.srcImage}
                  alt="image"
                  objectFit="cover"
                  fill
                  className="object-center"
                />
                {/* 
                  <div>
                    <img src={usFlag} className="h-64 w-full object-cover" />
                  </div>
                */}
              </div>

              <div className="mx-4 flex flex-col gap-4 my-4">
                <Head3 maxLines={2} isClamp={true}>
                  {items?.title ? items?.title : '-'}
                </Head3>
                <BodySmall className="hidden md:block">
                  {items?.datePost ? items?.datePost : '-'}
                </BodySmall>
                <div className="hidden md:block">
                  <BodySmall maxLines={3} isClamp={true}>
                    {items?.subtitle ? items?.subtitle : '-'}
                  </BodySmall>
                </div>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};

export default CardInfo;
